module.exports = __webpack_public_path__ + "img/logo.887cd6a9.svg";